import { render } from "./status.svg?vue&type=template&id=1c704214"
const script = {}

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__